import { UserProfile } from '@dynamic-labs/sdk-react-core';

import { ActiveUser, PublicUser } from '@repo/types-client';

export const getAddresses = (
  activeUser: ActiveUser,
  isDynamicUser: boolean,
): string[] => {
  if (!activeUser) return [];
  if (isDynamicUser) {
    return (
      (activeUser as UserProfile).verifiedCredentials
        ?.filter((cred) => cred.chain !== 'solana')
        ?.map((cred) => cred.address?.toLowerCase())
        .filter((address): address is string => address !== undefined) || []
    );
  } else {
    return (
      (activeUser as PublicUser).wallets.ethereum
        .map((wallet) => wallet.address?.toLowerCase())
        .filter((address): address is string => address !== undefined) || []
    );
  }
};
